import SplitText from 'plugins/SplitText.min';

class HomepageTop {
  constructor(node, options = {}) {
    this.props = {
      rootMargin: '0px 0px 0px 0px',
      threshold: 1.0,
      ...options,
    };
    this.node = node;
    this.node.decorator = this;
    this.intro = this.node.querySelector('.intro p');
    this.hints = this.node.querySelectorAll('.hints hint-component');

    this.split = new SplitText(this.intro, {
      type: 'lines',
      wordDelimiter: ' ',
    });

    this.animationRan = false;
    this.logoAnimationDone = options.homepageTop === 'animateImmediately';

    this.init();
    this.registerObserver();
  }

  init = () => {
    for (let i = 0; i < this.split.lines.length; i++) {
      const line = this.split.lines[i];
      line.classList.add('animate-stagger');
      line.style.animationDelay = `${0.1 + 0.1 * i}s`;
    }

    if (!this.logoAnimationDone) {
      window.addEventListener('logo-anim-done', () => {
        this.node.classList.remove('animate-visible');
        this.logoAnimationDone = true;

        if (!this.animationRan) {
          this.animate();
        }
      });
    }
  };

  animate = () => {
    if (!this.logoAnimationDone) return;

    this.node.classList.add('animate-visible');
    this.animationRan = true;

    setTimeout(() => {
      this.split.revert();
    }, 1400 + this.split.lines.length * 0.1);
  };

  registerObserver = () => {
    const { rootMargin, threshold } = this.props;
    this.observer = new IntersectionObserver(this.onIntersection, {
      rootMargin,
      threshold,
    });
    this.observer.observe(this.node);
  };

  onIntersection = entries => {
    entries.forEach(({ intersectionRatio }) => {
      if (intersectionRatio > 0) {
        this.animate();

        this.observer.unobserve(this.node);
      }
    });
  };
}

export default (node, props) => new HomepageTop(node, props);
